import { Component, Input} from '@angular/core';
export class SubscriptionsComponent {

   subscriptions: any[];
   loading: boolean;
constructor() {}
/**
 * @return {?}
 */
checkForSubscriptions() {
    if (this.subscriptions && this.subscriptions.length === 0) {
      return true;
    } else {
      return false;
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'slb-subscriptions',
  template: "<md-spinner [class.show]=\"loading\" *ngIf=\"loading\"></md-spinner> <div *ngIf=\"!loading\"> <div class=\"cards-view\" fxLayout=\"row\" fxLayoutWrap fxLayoutGap=\"20px\" *ngIf=\"!checkForSubscriptions(); else message\"> <md-card class=\"card\" *ngFor=\"let tile of subscriptions;let i = index\"> <img class=\"card-image\" md-card-image src=\"assets/images/Petrel_1.PNG\"> <md-card-content> <h3 md-line>{{tile.name}}</h3> <p md-line>Active Until - {{tile.expiration | date}}</p> </md-card-content> <md-card-actions> <div fxLayout=\"row\"> <a href=\"{{tile.launcherUrl}}\" target=\"_blank\"> <button md-button color=\"primary\">Launch</button> </a> </div> </md-card-actions> </md-card> </div> <ng-template #message> <p class=\"no-subscription\">No subscription found</p> </ng-template> </div> ",
  styles: ["md-spinner { width: 4.5em; } .cards-view { padding: 30px; } .card { border-radius: 5px; margin-bottom: 10px; } .card-image { width: 250px; height: 140px; border-radius: 5px 5px 0 0; } .no-subscription { position: absolute; top: 50%; left: 50%; }"],

}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'subscriptions': [{ type: Input },],
'loading': [{ type: Input },],
};
}

function SubscriptionsComponent_tsickle_Closure_declarations() {
/** @type {?} */
SubscriptionsComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
SubscriptionsComponent.ctorParameters;
/** @type {?} */
SubscriptionsComponent.propDecorators;
/** @type {?} */
SubscriptionsComponent.prototype.subscriptions;
/** @type {?} */
SubscriptionsComponent.prototype.loading;
}



interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
